(ns machtfit.stepchall.team-members
  (:require [machtfit.format :as format]
            [machtfit.stepchall.date :as date]
            [machtfit.stepchall.message :as message]
            [machtfit.stepchall.subs :as subs]
            [machtfit.translation :refer [tr t format-date]]
            [machtfit.utils :as utils]
            [re-frame.core :as rf]))

(defn- ranked [{:keys [team-members step-count deactivated?]}]
  (->> team-members
       (map #(assoc %
                    :step-count (step-count %)
                    :deactivated? (deactivated? %)))
       (sort-by (juxt :deactivated? #(- (:step-count %)) :nickname))
       (utils/map-ranked :step-count (fn [rank member] (assoc member :rank rank)))))

(rf/reg-sub ::own-team-members-ranked
  :<- [:get [:stepchall :team :members]]
  :<- [::date/stats-date]

  (fn [[team-members stats-date-kw] _]
    (let [stats-date (format/keyword->date stats-date-kw)]
      (ranked {:team-members team-members
               :step-count (case stats-date-kw
                             :all #(-> % :step-counts :total)
                             #(-> % :step-counts :daily stats-date-kw))
               :deactivated? (if (= stats-date-kw :all)
                               #(some? (-> % :deactivated-at-date))
                               #(and (some? (-> % :deactivated-at-date))
                                     (<= (-> % :deactivated-at-date) stats-date)))}))))

(rf/reg-sub ::ranked-own-team-member
  :<- [::own-team-members-ranked]

  (fn [team-members-ranked [_ index]]
    (nth team-members-ranked index)))

(rf/reg-sub ::team-members-ranked
  :<- [::subs/members-for-team]

  (fn [team-members _]
    (ranked {:team-members team-members
             :step-count #(-> % :step-counts :total)
             :deactivated? #(some? (-> % :deactivated-at-date))})))

(rf/reg-sub ::ranked-team-member
  :<- [::team-members-ranked]

  (fn [team-members-ranked [_ index]]
    (nth team-members-ranked index)))

(rf/reg-sub ::count-team-members
  :<- [::subs/teams-by-id]
  :<- [:get [:ui :page :team-id]]

  (fn [[teams team-id] _]
    (:member-count (teams team-id))))

(defn- team-member-single [index]
  (let [my-team-page? (= @(rf/subscribe [:get [:ui :page :subpage]]) :my-team)
        ranked-team-member (if my-team-page?
                             @(rf/subscribe [::ranked-own-team-member index])
                             @(rf/subscribe [::ranked-team-member index]))
        {:keys [rank
                nickname
                team-founder?
                step-count
                deactivated?
                deactivated-at-date]} ranked-team-member
        show-rank? (and (not deactivated?)
                        (pos? step-count))]
    [:div.sc_team-members-single {:class (when (= nickname @(rf/subscribe [:get [:stepchall :participant :nickname]])) "own-member")
                                  :style {:animation--delay (str (/ index 10) "s")}}
     [:div.rank (if show-rank? rank "-")]
     [:div.name nickname
      (when team-founder?
        [:span.sc_team-founder
         (t {:de "Gründer:in"
             :en "Founder"})])]
     (when my-team-page?
       [message/send-message-team-member-button ranked-team-member])
     [:div.steps (if deactivated?
                   [:span.deactivated
                    (tr "Wertung beendet")
                    (when (= @(rf/subscribe [::date/stats-date]) :all)
                      (str " (" (format-date deactivated-at-date) ")"))]
                   (format/decimal step-count))]]))

(defn- team-member-placeholder []
  [:div.sc_team-members-single
   [:div.rank [:span.content-placeholder]]
   [:div.name [:span.content-placeholder]]
   [:div.steps [:span.content-placeholder]]])

(defn team-members []
  (let [my-team-page? (= @(rf/subscribe [:get [:ui :page :subpage]]) :my-team)
        member-count (if my-team-page?
                       @(rf/subscribe [:get [:stepchall :team :member-count]])
                       @(rf/subscribe [::count-team-members]))
        main-unit-plural @(rf/subscribe [:get [:stepchall :main-unit :plural]])]
    [:div.sc_team-members
     [:div.sc_team-members-header
      [:div.members (t {:de "Mitglieder"
                        :en "Members"}) " (" member-count ")"
       (when my-team-page?
         [message/send-message-team-button])]
      [:div.steps-count (t main-unit-plural)]]
     (into [:div]
           (if (and (not my-team-page?)
                    (nil? @(rf/subscribe [::subs/members-for-team])))
             (repeat member-count [team-member-placeholder])
             (for [index (range member-count)]
               [team-member-single index])))]))
